<template>
  <div class="modal" id="modal" @click="closeModal">
    
      <div class="box">
        <h3 class="smokeheadlineh3">
          {{ $t("initial_modal_headline") }}
        </h3>

        <div class="installGuideContainer">
          <div
            class="browserInstallGuide"
            v-for="browser in browserInstallData"
            :key="browser.headline"
          >
            <p class="installGuideHeadline">
              {{ $t(browser.headline) }}
            </p>

            <p v-for="count in browser.steps" :key="count">
              {{ $t(browser.installStepTitle + count) }}
            </p>
          </div>
        </div>

        <p class="mb-4">{{ $t("initial_modal_instalguide_info") }}</p>
        <p class="installGuideHeadline">
          {{ $t("initial_modal_offline_usage_headline") }}
        </p>
        <p>{{ $t("initial_modal_offline_usage_info") }}</p>

        <div class="d-flex">
          <button class="saveButton" id="closeBtn" @click="closeModal">
            <p id="closeBtn">{{ $t("close") }}</p>
          </button>
        </div>
      </div>
  </div>
</template>

<script>
import { storageAdapter } from "@/services/storageAdapter";
export default {
  name: "InitialOfflineModal",

  data() {
    return {
      allowedLanguages: ["de", "en"],
      browserInstallData: [
        {
          headline: "install_guide_headline_safari",
          steps: 3,
          installStepTitle: "install_steps_safari"
        },
        {
          headline: "install_guide_headline_chrome",
          steps: 2,
          installStepTitle: "install_steps_chrome"
        },
        {
          headline: "install_guide_headline_firefox",
          steps: 2,
          installStepTitle: "install_steps_firefox"
        }
      ]
    };
  },
  computed: {
    modalWidth() {
      if (window.innerWidth <= 575) {
        return "100%";
      } else {
        return "70%";
      }
    }
  },
  methods: {
    closeModal(e) {
      if (
        e.target.id === "modal" || e.target.id === "closeBtn"
      ) {
        storageAdapter("offlineModeWasInitialized").set("true");
        this.$store.state.wasOfflineModeInitialized = storageAdapter(
        "offlineModeWasInitialized"
      ).get();
      }
      
      
    }
  }
};
</script>

<style scoped>
.modal-initial {
  z-index: 1040;
  height: 100% !important;
  min-height: 100% !important;
  overflow-y: auto;
}
.smokeheadlineh3 {
  text-align: left;
  color: limegreen;
  font-family: Netto Bold, Open Sans, sans-serif;
}
.box {
  margin: 5%;
  padding: 5%;
  background-color: white;
}
.saveButton {
  color: #00aeef;
  margin-left: auto;
  margin-top: 1rem;
}

.installHeadline {
  font-family: Netto Bold, Open Sans, sans-serif;
  margin-bottom: 1.5rem;
}
.browserInstallGuide {
  margin-bottom: 1.5rem;
}
.installGuideHeadline {
  font-family: Netto Bold, Open Sans, sans-serif;
}

.installGuideContainer {
  padding-top: 2rem;
}

.modal{
  position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
}
</style>
